import type {
	FetchPolicy,
	QueryResultWithRefetch,
} from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import { useExperimentalQueryBase } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQueryBase.ts';
import { experimentalMacroMetadata } from '@confluence/graphql/entry-points/experimentalMacroMetadata.ts';
import type { ResolverContext } from '@confluence/graphql/entry-points/ResolverContext.ts';
import { cfetch } from '@confluence/network';

import type {
	ExcerptIncludeQuery as ExcerptIncludeQueryData,
	ExcerptIncludeQueryVariables,
} from './__types__/ExcerptIncludeQuery.ts';

export const useExperimentalMacroMetadataQuery = ({
	variables,
	skip = false,
	fetchPolicy = 'cache-first',
}: {
	variables: ExcerptIncludeQueryVariables;
	skip?: boolean;
	fetchPolicy?: FetchPolicy;
}): QueryResultWithRefetch<ExcerptIncludeQueryData, ExcerptIncludeQueryVariables> => {
	const fetchData = async (): Promise<ExcerptIncludeQueryData> => {
		const result = await experimentalMacroMetadata({}, variables, {
			network: { cfetch } as unknown as ResolverContext['network'],
		});

		return {
			experimentalMacroMetadata: result
				? {
						payload: result.payload ?? null,
						contentId: result.contentId ?? null,
					}
				: null,
		};
	};

	const key = JSON.stringify({ query: 'experimentalMacroMetadata', variables });

	return useExperimentalQueryBase<ExcerptIncludeQueryData, ExcerptIncludeQueryVariables>({
		key,
		fetchData,
		variables,
		skip,
		fetchPolicy,
	});
};
